<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot">I thrust my arms wildly above and around me in all directions. I felt nothing: yet dreaded to move a step, lest I should be impeded by the walls of a tomb.</p>
<p class="epc"><span class="epub-sc">EDGAR ALLAN POE</span>, ‘The Pit and the Pendulum’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?f2a41ea8